// extracted by mini-css-extract-plugin
module.exports = {"hoverLift":"MeetingQueueManagement_hoverLift__CqBwm","refreshButton":"MeetingQueueManagement_refreshButton__7j_RG","meetingCard":"MeetingQueueManagement_meetingCard__ll7mI"};